import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import StepWizard from "react-step-wizard";
import SelectBrand from "./SelectBrand";
import TagLayout from "./TagLayout";
import OrderDetailForm from "./OrderDetailForm";
import OrderProducts from "./OrderProducts";
import {createOrderActions} from "../../../redux/actions/create-order-actions";
import {brandActions} from "../../../redux/actions/brand-actions";
import $ from "jquery";

class CreateOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            brands: [],
            selectedBrand: null,
            tags: [],
            selectedTaglayout: null,
            orderSteps: {},
            dataDefinition: {},
            productAttributes: [],
            brand_definition_order_steps: [],
            orderAttributes: [],
            filterAttributes: [],
            step: 1,
            prevStepNum: 0,
            nextStepNum: 1,
            tagsFilter: "",
            tagsPages: 0,
            tagsCurrent_page: 1,
            tagsPageSize: 8,
            selectedFilterAttributes: [],
            selectAddAll: false,
            cart: {}
        };
    }

    componentDidMount = () => {
        this.props.getAllBrandsCall(1, "", "", 10).then(
            response => {
                if (this.props.brands.length > 1) {
                    if (this.props.history.location.state) {
                        const oldBrands = [...this.props.brands];

                        const brand = this.props.history.location.state.selectedBrand;
                        oldBrands.forEach(brd => {
                            if (brd.brand_id === brand.brand_id) {
                                brd.isSelected = true
                            }
                        })
                        brand.isSelected = true;
                        this.setState({
                            ...this.state,
                            brands: oldBrands,
                            selectedBrand: brand
                        });
                        return;
                    }

                    this.setState({
                        ...this.state,
                        brands: this.props.brands
                    });
                } else {
                    const oldBrands = [...this.props.brands];
                    const newBrands = oldBrands;
                    newBrands[0].isSelected = !newBrands[0].isSelected;

                    this.setState({
                        ...this.state,
                        brands: this.props.brands,
                        selectedBrand: newBrands[0]
                    });
                }
            },
            error => {
                return error;
            }
        );
    }

    selectedLogo = (listType, arrList, index) => {
        const oldBrands = [...arrList];
        const newBrands = oldBrands;
        newBrands.forEach(function (item, index) {
            newBrands[index].isSelected = false;
        });
        newBrands[index].isSelected = !newBrands[index].isSelected;

        this.setState({
            brands: newBrands,
            selectedBrand: newBrands[index]
        });
    };

    setWizardHeight = () => {
        setTimeout(function () {
            $("html,body")
                .stop(true, true)
                .animate({scrollTop: "0"}, 500, "linear");
        }, 300);
    };

    processStepOne = response => {
        const {brand_id} = this.state.selectedBrand;
        this.setState({
            ...this.state,
            orderSteps: response.orderSteps,
            nextStepNum: response.nextStepNum,
            prevStepNum: response.prevStepNum,
            dataDefinition: response.dataDefinition,
            productAttributes: response.dataDefinition.product_attributes,
            exportAttributes: response.dataDefinition.export_attributes,
            orderAttributes: response.dataDefinition.order_attributes,
            brand_definition_order_steps: response.brand_definition_order_steps
        });

        let attributes = [];
        response.brand_definition_order_steps.forEach(item => {
            attributes = [...attributes, item];
        });
        this.setState(prevState => ({
            filterAttributes: attributes
        }));
        this.setState(prevState => ({
            selectedFilterAttributes: []
        }));

        switch (response.action) {
            case "get_tag_layouts":
                return this.props
                    .getAllTagLayoutsCall(
                        brand_id,
                        this.state.tagsFilter,
                        this.state.tagsCurrent_page,
                        "",
                        this.state.tagsPageSize
                    )
                    .then(response => {
                        this.setState({
                            ...this.state,
                            tags: this.props.taglayoutsData,
                            tagsPages: this.props.tagsPages,
                            tagsCurrent_page: this.props.tagsCurrent_page
                        });
                    });
            case "get_po_lookup":
                return this.props
                    .getAllTagLayoutsCall(
                        brand_id,
                        this.state.tagsFilter,
                        this.state.tagsCurrent_page,
                        "",
                        this.state.tagsPageSize
                    )
                    .then(response => {
                        this.setState({
                            ...this.state,
                            tags: this.props.taglayoutsData,
                            tagsPages: this.props.tagsPages,
                            tagsCurrent_page: this.props.tagsCurrent_page
                        });
                    });
            default:
                return '';
        }
    };

    tagLayoutsPageChange = val => {
        this.setState({
            ...this.state,
            tagsCurrent_page: val
        }, () => {
            this.processStepOne({
                orderSteps: this.state.orderSteps,
                brand_definition_order_steps: this.state.brand_definition_order_steps,
                dataDefinition: this.state.dataDefinition,
                action: "get_tag_layouts",
                nextStepNum: 3,
                prevStepNum: 1
            });
        });
    };
    tagLayoutsFilterChange = val => {
        this.setState({
            ...this.state,
            tagsFilter: val
        }, () => {
            this.processStepOne({
                orderSteps: this.state.orderSteps,
                brand_definition_order_steps: this.state.brand_definition_order_steps,
                dataDefinition: this.state.dataDefinition,
                action: "get_tag_layouts",
                nextStepNum: 3,
                prevStepNum: 1
            });
        });

    };

    selectedTaglayout = (listType, arrList, idx, nextStepNum) => {
        //alert(stepNum);
        const oldList = [...arrList];
        const newList = oldList;
        newList.forEach(function (item, index) {
            newList[index].isSelected = false;
        });
        newList[idx].isSelected = !newList[idx].isSelected;
        this.setState({
            tags: newList,
            selectedTaglayout: newList[idx]
        });
    };

    getLookupState = (state, remove = false) => {
        console.log('this.ist',state)
        this.setState({
            selectedFilterAttributes: state
        })
        return;
        if (remove) {
            const filtering = this.state.selectedFilterAttributes.filter(item => item.attribute_id !== state.selectValue.attribute_id);
            this.setState({
                selectedFilterAttributes: filtering
            });
            return;
        }
        this.setState(prevState => ({
            selectedFilterAttributes: [
                ...prevState.selectedFilterAttributes.filter(
                    item => {
                        return item.attribute_id !== state.selectValue.attribute_id
                    }
                )
            ]
        }), () => {
            this.setState(prevState => ({
                selectedFilterAttributes: [
                    ...prevState.selectedFilterAttributes,
                    state.selectValue
                ]
            }));
        });
    };

    resetLookupState = () => {
        this.setState({
            selectedFilterAttributes: [],
            selectAddAll: false
        });
    };

    render() {
        return (
            <React.Fragment>
                <StepWizard
                    initialStep={this.state.step}
                    onStepChange={this.setWizardHeight}
                >
                    <SelectBrand
                        brands={this.state.brands}
                        selectedBrand={this.state.selectedBrand}
                        selectedLogo={(listType, arrList, index) =>
                            this.selectedLogo(listType, arrList, index)
                        }
                        onBrandSelection={this.processStepOne}
                        movedFromOpenCart={!!(this.props.history.location.state)}
                    />
                    <TagLayout
                        tags={this.state.tags}
                        selectedBrand={this.state.selectedBrand}
                        tagsPages={this.state.tagsPages}
                        tagsCurrentPage={this.state.tagsCurrent_page}
                        orderSteps={this.state.orderSteps}
                        prevStepNum={
                            this.state.nextStepNum === 2
                                ? 3
                                : this.state.prevStepNum
                        }
                        nextStepNum={this.state.nextStepNum}
                        selectedTaglayout={(listType, arrList, index) =>
                            this.selectedTaglayout(listType, arrList, index)
                        }
                        onTagLayoutsPageChange={this.tagLayoutsPageChange}
                        onTagLayoutsFilterChange={this.tagLayoutsFilterChange}
                        selectedTag={this.state.selectedTaglayout}
                        filterAttributes={this.state.filterAttributes}
                        tagsFilter={this.state.tagsFilter}
                        showTagListOnly={false}
                    />
                    <OrderProducts
                        tags={this.state.tags}
                        tagsPages={this.state.tagsPages}
                        selectedTaglayoutFunction={(listType, arrList, index) =>
                            this.selectedTaglayout(listType, arrList, index)
                        }

                        getLookupState={this.getLookupState}
                        orderSteps={this.state.orderSteps}
                        selectedBrand={this.state.selectedBrand}
                        selectedTag={this.state.selectedTaglayout}
                        filterAttributes={this.state.filterAttributes}
                        selectedFilterAttributes={
                            this.state.selectedFilterAttributes
                        }
                        selectedTaglayout={this.state.selectedTaglayout}
                        prevStepNum={this.state.nextStepNum === 3
                            ? 2
                            : this.state.prevStepNum}
                        productAttributes={this.state.productAttributes}
                        orderAttributes={this.state.orderAttributes}
                        cart={this.props.cartInfo}
                        showListOnly="false"
                        selectAddAll={this.state.selectAddAll}
                        resetLookupState={this.resetLookupState}
                        tagsFilter={this.state.tagsFilter}
                        onTagLayoutsPageChange={this.tagLayoutsPageChange}
                        onTagLayoutsFilterChange={this.tagLayoutsFilterChange}
                    />
                    <OrderDetailForm
                        hasShippingAddresses={true}
                        hasBillingAddresses={true}
                        productAttributes={this.state.productAttributes}
                        orderAttributes={this.state.orderAttributes}
                        exportAttributes={this.state.exportAttributes}
                        selectedTaglayout={this.state.selectedTaglayout}
                        selectedBrand={this.state.selectedBrand}
                        cart={this.props.cartInfo}
                        filterAttributes={this.state.filterAttributes}
                        selectedFilterAttributes={
                            this.state.selectedFilterAttributes
                        }
                        showViewCart="true"
                        fromCartPage="false"
                        canChangeStatus="false"
                        resetLookupState={this.resetLookupState}
                    />
                </StepWizard>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllBrandsCall: () => {
            return dispatch(
                createOrderActions.getCustomerBrandsList(true)
            );
        },
        getAllTagLayoutsCall: (id, filter, page, sort, pageSize) => {
            let resource_id = "";
            if (id !== undefined) {
                resource_id = id;
            } else {
                resource_id = "all";
            }
            return dispatch(
                brandActions.getBrandTagLayoutsPagination(
                    resource_id,
                    filter,
                    page,
                    sort,
                    pageSize,
                    true //? added for getting only enabled tags 
                )
            );
        }
    };
};

function mapStateToProps(state) {
    const {brands, cartInfo} = state.createOrdersReducer;

    const {taglayoutsData, pages, current_page} = state.brandReducer;
    return {
        brands,
        taglayoutsData,
        tagsPages: pages,
        tagsCurrent_page: current_page,
        cartInfo
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CreateOrder)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/CreateOrder.jsx